export default [
  {
    path: '/franchisee/managment',
    meta: {
      title: '店铺管理',
    },
    component: () => import('@/views/franchisee/managment'),
  },
  {
    path: '/franchisee/audit',
    meta: {
      title: '店铺审核',
    },
    component: () => import('@/views/franchisee/audit'),
  },
  {
    path: '/franchisee/shopTypes',
    meta: {
      title: '门店类型管理',
    },
    component: () => import('@/views/franchisee/shopTypes.vue'),
  },
]